import groq from 'groq';

export const blockBagSectionFields = groq`
  ...,
`;
